import { twMerge } from 'tailwind-merge';

import ConduitHealthLoader from './ConduitHealthLoader';
import { useGlobalLoaderStore } from './useGlobalLoader';

export default function GlobalLoader() {
  const loaderVisible = useGlobalLoaderStore((s) => s.loaderVisible);

  return (
    <>
      <div
        className={twMerge(
          'absolute top-[64px] left-0 z-40 h-full w-full bg-white opacity-0 transition-opacity duration-500',
          loaderVisible ? 'opacity-80' : 'invisible'
        )}
      />
      <div
        className={twMerge(
          'absolute top-1/2 left-1/2 z-40 -translate-x-1/2 -translate-y-1/2 transform opacity-0 transition-opacity duration-500',
          loaderVisible ? 'opacity-100' : 'invisible'
        )}
      >
        <ConduitHealthLoader size="large" />
      </div>
    </>
  );
}
